<template>
  <div class="container">
    <app-header title="确认订单"  :is-back="isBack" @back="back"/>

    <!-- 添加收货地址 -->
    <div class="order-header" v-if="addressList.length == 0">
      <div class="address">
        <img src="@/assets/add.png" alt="添加收货地址" width="20" height="20">
        <span class="add" @click="handleAddress">添加收货地址</span>
      </div>
    </div>
    <!-- 订单地址 -->
    <div class="order-address" v-else>
      <div class="order-address-main"  v-for="(item,index) in addressList" :key="index" v-if="index == 0" @click="handleAddress">
        <img src="@/assets/address.png" alt="订单地址" width="38" height="38">
        <div class="content">
          <div class="name">{{item.name}}</div>
          <div class="tel">{{item.tel}}</div>
          <div class="address">{{item.address }} {{item.detail}}</div>
        </div>
        <img src="@/assets/addgo.png" alt="更多" width="20" height="20">
      </div>
    </div>
    <!-- 商品信息 -->
    <div class="product">
      <div class="product-info" v-for="(item,index) in rows" :key="index" style="margin-bottom: 10px;">
        <img :src="item.shopProduct.image" alt="" width="98" height="98">
        <div class="content">
          <div class="title">{{item.shopProduct.name}} * {{item.shopProduct.number}}*{{item.shopProduct.unitNumber}}</div>
          <div class="price">￥{{item.shopProduct.price}}</div>
          <div class="sku">已选: {{item.shopProduct.description}}</div>
          <div class="total">
            <div style="margin-right: 31px">共{{value}}件，小计：￥{{(($route.query.price)*value*item.shopProduct.unitNumber).toFixed(2)}}</div>
          </div>
        </div>
      </div>


      <div class="postage">
        <div>
          <span>配送方式: </span>
          <!--<span style="color: #C7C7C7;">普通配送</span>-->
        </div>
        <span @click="expressShow=true">
          <span>{{expressName}}</span>
          <span v-if="expressActive>=0 && form.shippingAmount>0">{{form.shippingAmount}}元</span>
          <span v-if="expressActive>=0 && form.shippingAmount==0">免费</span>
          <img src="@/assets/right01.png" alt="" width="13" height="13">
        </span>
      </div>
      <!--选择快递弹窗-->
      <van-popup v-model="expressShow" round position="bottom" :style="{ height: '35%' }" >
        <div class="popup">
          <div class="popuphead">
            <div class="close" @click="expressShow = false">
              <img src="@/assets/close.png" alt="" width="14px">
            </div>
            <div class="confirm" @click="expressShow = false">确定</div>
          </div>
          <div class="type" @click="selectDesc(0,'快递')" :class="expressActive==0?'active':''">快递</div>
          <div class="type" @click="selectDesc(1,'物流')":class="expressActive==1?'active':''">物流</div>
          <div class="type" @click="selectDesc(2,'自提')":class="expressActive==2?'active':''">自提</div>
        </div>
      </van-popup>

      <div class="ticket" @click="couponShow = true" v-if="!checked">
        <div>
          <span>优惠券: </span>
          <span style="color: #C7C7C7;">{{couponTip}}</span>
        </div>
        <span>
          <span class="text" v-if="form.couponPrice">-￥{{form.couponPrice}}</span>
          <span class="text" v-else>不使用优惠券</span>
          <img src="@/assets/right01.png" alt="" width="13" height="13">
        </span>
      </div>

      <van-popup v-model="couponShow" round position="bottom" :style="{ height: '35%' }" >
        <div class="popup">
          <div class="popuphead">
            <div class="close" @click="couponShow = false">
              <img src="@/assets/close.png" alt="" width="14px">
            </div>
            <div class="confirm" @click="couponShow = false">确定</div>
          </div>
          <div class="choose">
            <van-radio-group v-model="activeCoupon" @change="changeCoupon">
              <div class="item" v-for="(item,index) in couponList"  v-if="item.conditions <= total">
                <div class="name">
                  <img src="@/assets/pay03.png" alt="" width="20" height="20">
                  <span class="text">{{item.title}}({{item.money}}元)</span>
                </div>
                <van-radio :name="item.id" class="radio" checked-color="#FE003B" @click.native.prevent="radioClick(item.id)"></van-radio>
              </div>
              <div class="item">
                <div class="name">
                  <img src="@/assets/pay03.png" alt="" width="20" height="20">
                  <span class="text">不使用优惠券</span>
                </div>
                <van-radio :name="0" class="radio" checked-color="#FE003B" @click.native.prevent="radioClick(0)"></van-radio>
              </div>
            </van-radio-group>
          </div>
        </div>
      </van-popup>


      <div class="ticket" @click="onNavigate">
        <div>
          <span>开具发票: </span>
          <span style="color: #C7C7C7;" v-if="currentItem">{{$enums.TicketType[currentItem.type]}}</span>
        </div>
        <span>{{currentItem?currentItem.companyName:'本次不开具发票'}}
          <img src="@/assets/right01.png" alt="" width="13" height="13">
        </span>
      </div>

      <div class="ticket" v-if="currentItem && currentItem.type==0">
        <div style="width: 60px">
          <span>发票类型: </span>
        </div>
        <van-radio-group v-model="form.opentype" @change="changeOpenType">
          <van-radio :name="0" checked-color="#FE003B">累计开</van-radio>
          <van-radio :name="1" checked-color="#FE003B" v-if="totalMoney >=500">随货发 <span style="color: #E10F02;font-size: 11px;">(满500元可以开票)</span></van-radio>
        </van-radio-group>
      </div>
      <div class="ticket" v-if="currentItem && currentItem.type==1">
        <div style="width: 60px">
          <span>发票类型: </span>
        </div>
        <van-radio-group v-model="form.opentype" @change="changeOpenType">
          <van-radio :name="0" checked-color="#FE003B">纸质发票</van-radio>
          <van-radio :name="1" checked-color="#FE003B" v-if="electronicsTicket">电子发票</van-radio>
        </van-radio-group>
      </div>
    </div>
    <!-- 支付方式 -->
    <div class="payment">
      <div class="title">支付方式选择：</div>
      <div class="content">
        <div class="item" @click="changeOnline(0)">
          <div class="item-img" :style="form.isOnlinepay==0?'background:linear-gradient(52deg,rgba(253,12,13,1) 0%,rgba(249,20,22,0.58) 100%)':'background:linear-gradient(52deg,rgba(161,161,161,1) 0%,rgba(169,169,169,0.58) 100%)'">
            <img src="@/assets/pay02.png" alt="" width="24" height="24">
          </div>
          <span class="name">线上支付</span>
        </div>
        <div class="item" @click="changeOnline(1)" >
          <div class="item-img" :style="form.isOnlinepay==1?'background:linear-gradient(52deg,rgba(253,12,13,1) 0%,rgba(249,20,22,0.58) 100%)':'background:linear-gradient(52deg,rgba(161,161,161,1) 0%,rgba(169,169,169,0.58) 100%)'">
            <img src="../../assets/pay01.png" alt="" width="24" height="24">
          </div>
          <span class="name">线下支付</span>
        </div>
      </div>
      <div class="tip" v-if="form.isOnlinepay==1">（提示: 转对公账号，只能增值税专用票）</div>
    </div>
    <div class="payment" v-show="form.isOnlinepay==1">
      <div class="title" style="color: #FF0000;">对公账户信息</div>
      <div>
        <div style="display: flex;margin-top: 0.5625rem;">
          <div style="width: 85px">公司名称:</div>
          <div style="flex: 1;">{{companyName}}</div>
        </div>
        <div style="display: flex;margin-top: 0.5625rem;">
          <div style="width: 85px">开户行　:</div>
          <div>{{bankName}}</div>
        </div>
        <div style="display: flex;margin-top: 0.5625rem;">
          <div style="width: 85px">开户账号:</div>
          <div>{{bankCode}}</div>
        </div>
      </div>
      <div class="title" style="margin-top: 1.25rem;margin-bottom: 20px;">上传转账回单</div>
      <van-uploader
        :max-count='1'
        :file-list="fileList"
        :after-read="afterRead"
        @delete='deleteImg'
      />
    </div>

    <!--<div class="payment">-->
      <!--<div class="title">可用优惠券：</div>-->
      <!--<div class="choose">-->
        <!--<van-radio-group v-model="activeCoupon" @change="changeCoupon">-->
          <!--<div class="item" v-for="(item,index) in couponList" v-if="item.conditions <= totalMoney">-->
            <!--<div class="name">-->
              <!--<img src="@/assets/pay03.png" alt="" width="20" height="20">-->
              <!--<span class="text">{{item.title}}</span>-->
            <!--</div>-->
            <!--<van-radio :name="item.id" class="radio" checked-color="#FE003B" @click.native.prevent="radioClick(item.id)"></van-radio>-->
          <!--</div>-->
        <!--</van-radio-group>-->
        <!--</div>-->
    <!--</div>-->
    <!--返利金额抵扣-->
    <div class="choose" v-if="userInfo.income > 0 && !form.cid">
      <div class="item" @click="checked = !checked">
        <div class="name">
          <img src="@/assets/pay03.png" alt="" width="20" height="20">
          <span class="text">返利金最多抵当次总额的30%</span>
        </div>
        <div>
          <van-checkbox v-model="checked" checked-color="#FE003B" @change="incomeCharge"></van-checkbox>
        </div>
      </div>
      <div style="color: red;text-align: center">可抵扣返利金：{{form.incomePrice}}元</div>
    </div>

    <div class="choose" v-show="form.isOnlinepay==0">
      <van-radio-group v-model="form.payType">
        <div class="item" @click="form.payType=0">
          <div class="name">
            <img src="@/assets/pay04.png" alt="" width="20" height="20">
            <span class="text">余额支付</span>
          </div>
          <van-radio :name="0" class="radio" checked-color="#FE003B"></van-radio>
        </div>
        <div class="item" @click="form.payType=1">
          <div class="name">
            <img src="@/assets/pay05.png" alt="" width="20" height="20">
            <span class="text">微信支付</span>
          </div>
          <van-radio :name="1" class="radio" checked-color="#FE003B"></van-radio>
        </div>
      </van-radio-group>
    </div>
    <div class="choose">
      <div class="name" style="margin-top: 15px;margin-bottom: 10px">备注</div>
      <textarea class="synopsis" v-model="form.remark" placeholder="请填写（200字以内）" maxlength="200"></textarea>
    </div>
    <div class="footer" >
      <div class="total" style="position: relative;">
        <span style="color: #666666;font-size: 12px">共{{$route.query.num}}件</span>
        <span style="height: 20px;font-size: 14px;font-weight: bold;line-height: 20px;color: #333333;">合计:</span>
        <img src="@/assets/down01.png" alt="" width="14" height="14">
        <span @click="isshowDetaile=!isshowDetaile" v-if="rows.length > 0" class="money">￥{{totalMoney}}</span>

        <div v-show="isshowDetaile" class="model">
          <div style="width: 100%;height: 100%;position: relative;">
            <div class="model-item">
              <span class="model-item-name"> 商品金额 </span>
              <span class="model-item-text" >￥ {{total}}</span>
            </div>
            <div class="model-item">
              <span class="model-item-name"> 快递费用 </span>
              <span class="model-item-text">￥  {{form.shippingAmount}}</span>
            </div>
            <div class="model-item">
              <span class="model-item-name"> 优惠劵 </span>
              <span class="model-item-text">-￥  {{form.couponPrice}}</span>
            </div>
            <div class="model-item">
              <span class="model-item-name"> 抵扣金额 </span>
              <span class="model-item-text">-￥  {{form.incomePrice}}</span>
            </div>
            <div class="model-item">
              <span class="model-item-name"> 返利金额 </span>
              <span  class="model-item-text">￥ {{flMoney}}</span>
            </div>
            <div style="width: 15px;height: 15px;background: #FFFFFF;transform: rotate(45deg);position: absolute;bottom: -9px;left: 50%;margin-left: -8px;border-bottom: 0.0625rem solid #DEDEDE;border-right: 1px solid #DEDEDE;"></div>
          </div>
        </div>
      </div>
      <div class="submit" @click="submit">提交订单</div>
    </div>
  </div>
</template>

<script>
import { saveShopOrder, wxPayServiceFee, queryorder, queryShopCorporateAccountList, querySysRebateList,generateBuyOrder } from '@/api/order'
import { queryShopAddressList } from '@/api/address'
import { usableCoupon } from '@/api/coupon'
import { getSysSetting } from '@/api/system'
import { queryShopServiceChargeList } from '@/api/ticket/index.js'
import {getCurtUser} from '@/api/login/index.js'
import Vue from 'vue'
import { Uploader } from 'vant'
import { uploadimage } from '@/api/file.js'
Vue.use(Uploader)
export default {
  name: 'Add',
  data() {
    return {
      isBack: false,
      query: {},
      show: true,
      userInfo: {},
      checked: false,
      //电子发票是否开启
      electronicsTicket: 0,
      companyName: '',
      bankName: '',
      bankCode: '',

      expressShow: false,
      expressActive: undefined,
      expressName: '请选择',
      expressMoney: 0,

      //优惠券
      couponShow: false,
      couponTip: '',

      radio: 2,
      value: 1,
      activeCoupon: '',
      activeCoupon1: '',
      addressList: [],
      rows: [],
      fileList: [],
      orderItemList: [],
      currentItem: '',
      couponList: [],
      ticketList: [],
      disabsold: false,
      isshowDetaile: false,
      flMoney: 0,
      form: {
        uid: '',
        sid: '',
        cid: '',
        sname: '',
        address: undefined,
        tel: undefined,
        receiver: undefined,
        couponPrice: 0,
        shopTicket: null,
        opentype: null,
        isOnlinepay: 0,
        payType: 1,
        totalPrice: '',
        realPrice: '',
        buyType: 2,
        receiptUrl: '',
        serviceCharge: 0,
        shippingAmount: 0,
        incomePrice: 0,
        coid: '',
        siid: '',
        freightType: '',
        isIssue: 0
      }
    }
  },
  computed: {
    total() {
      let total = 0;
      total = this.$route.query.price * this.value * this.$route.query.unitNumber;
      // total = (total + this.form.shippingAmount).toFixed(2)
      return total;
    },
    totalMoney(){
      let total = 0;
      total = this.$route.query.price * this.value * this.$route.query.unitNumber;
      total = (total - this.form.couponPrice  + this.form.shippingAmount).toFixed(2)
      if (this.checked){
        let max = (total * 0.3).toFixed(2);
        if (this.userInfo.income >= max) {
          this.form.incomePrice = max;
        }else{
          this.form.incomePrice = this.userInfo.income;
        }
      } else{
        this.form.incomePrice = 0;
      }
      total = (total - this.form.incomePrice).toFixed(2)
      return total;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name == 'ticketList' || from.name == 'addressList') {
        vm.currentItem = from.params.item
        if (vm.currentItem){
          vm.form.fid = from.params.item.id
          vm.form.isIssue = from.params.item.type + 1;
          // vm.form.serviceCharge = from.params.item.opentype ? from.params.item.serviceCharge : 0
          vm.form.coid = from.params.item.opentype ? from.params.item.coid : ''
          vm.form.shopTicket = from.params.item

        }
        if (from.query.form){
          let dataForm = JSON.parse(from.query.form);
          vm.form.freightType = dataForm.freightType
          //vm.form.shippingAmount = dataForm.shippingAmount
          vm.form.cid = dataForm.cid
          vm.form.siid = dataForm.siid
          vm.form.couponPrice = dataForm.couponPrice
          vm.expressActive = from.query.expressActive
          vm.expressName = from.query.expressName
          vm.couponTip = from.query.couponTip
        }
      }
    })
  },
  created() {
    //获取请求参数
    let query = this.$route.query;
    if (query){
      this.query = query;
      this.generateBuyOrder();
      this.orderItemList.push({
        pid: this.$route.query.pid,
        description: this.$route.query.gName,
        number: this.$route.query.num,
        price: (this.$route.query.price),
        sid: this.$route.query.sid,
        totalPrice: (this.$route.query.price) * this.$route.query.num * this.$route.query.unitNumber,
        image : this.$route.query.image
      })
      this.rows.push({
        shopProduct:{
          image : this.$route.query.image,
          description : this.$route.query.gName,
          name : this.$route.query.name,
          price: (this.$route.query.price),
          sid: this.$route.query.sid,
          number: this.$route.query.num,
          unitNumber: this.$route.query.unitNumber,
          totalPrice: this.$route.query.price * this.$route.query.num * this.$route.query.unitNumber,
        }
      })
      // this.form.totalPrice = (this.$route.query.price/100) * this.$route.query.num * this.$route.query.unitNumber
      //this.expressMoney = this.$route.query.freightMoney
    }

    //用户信息
    var user = localStorage.getItem("userInfo")
    if (!user){
      this.$router.push({path: '/login'})
      return;
    }
    user = JSON.parse(user)
    this.form.uid = user.id


    //获取用户信息
    this.getUser()

    //返利金额
    //this._querySysRebateList()

    // 获取对公账户
    this.getSysSetting()

    //获取优惠券信息
    this.getCouponList()
    this.value = this.$route.query.num


    // 收货地址
    let address = this.$route.query.address
    if (address){
      address = JSON.parse(address);
      this.addressList = [];
      this.addressList.push(address)
      this.form.receiver = address.name
      this.form.tel = address.tel
      this.form.address = address.address
      this.form.detail = address.detail
    } else{
      this.getList()
    }
  },
  methods: {
    generateBuyOrder(){
      this.query.expressActive = this.expressActive
      this.query.price = this.$route.query.price
      generateBuyOrder(this.query).then(res => {
        if (res.success) {
          this.form.totalPrice = res.data.totalMoney
          this.flMoney = res.data.incomeMoney
          this.expressMoney = res.data.shippingAmount
          //this.orderItemList = res.data.orderItemList
        }
      })
    },
    changeOnline(val){
      this.form.isOnlinepay = val
      if (val === 1){
        if(this.currentItem.type === 1){
          this.currentItem = ''
          this.form.fid = ''
          this.form.opentype = ''
          this.form.isIssue = ''
          this.form.coid =  ''
          this.form.shopTicket = null
        }
      }
    },
    back(){
      this.$router.push({
        path: '/home'
      })
    },
    incomeCharge(val){
      // if (val){
      //   let max = (this.totalMoney * 0.3).toFixed(2);
      //   if (this.userInfo.income >= max) {
      //     this.form.incomePrice = max;
      //   }else{
      //     this.form.incomePrice = this.userInfo.income;
      //   }
      // } else{
      //   this.form.incomePrice = 0;
      // }
    },
    getUser(){
      getCurtUser({id: this.form.uid}).then(res => {
        if (res.success) {
          this.userInfo = res.data
        }
      })
    },
    //电子发票是否开启
    getSysSetting(){
      getSysSetting({}).then(res=>{
        if (res.success){
          this.electronicsTicket = res.data.electronicsTicket
          this.companyName = res.data.companyName
          this.bankName = res.data.bankName
          this.bankCode = res.data.bankCode
        }
      })
    },
    selectDesc(index,name){
      this.expressActive = index
      this.expressName = name
      this.form.freightType = index
      if (index==2){
        this.form.shippingAmount = 0
      }else{
        this.form.shippingAmount = Number(this.expressMoney)
      }
      this.generateBuyOrder();
    },
    calcSelfAmount(){

    },
    pay(){
      this.form.orderItemList = this.orderItemList
      this.form.pid = this.$route.query.pid
      this.form.totalPrice = (this.$route.query.price * this.value * this.$route.query.unitNumber - this.form.couponPrice - this.form.incomePrice  + this.form.shippingAmount).toFixed(2)
      this.form.realPrice = (this.$route.query.price * this.value * this.$route.query.unitNumber - this.form.couponPrice - this.form.incomePrice + this.form.shippingAmount).toFixed(2)
      this.form.sname = this.$route.query.gName
      this.form.sid = this.$route.query.sid
      this.form.openid = localStorage.getItem('openid')

      if (localStorage.getItem('openid') == null) {
        var user = localStorage.getItem("userInfo")
        user = JSON.parse(user)
        this.form.openid = user.openid
      }

      if (this.form.freightType!==0 && this.form.freightType!==1 && this.form.freightType!==2) {
        this.$toast.fail('请选择配送方式')
        return
      }

      if(this.form.shopTicket){
        if(this.form.opentype == null || this.form.opentype === ''){
          this.$toast.fail('请选择发票类型')
          return
        }
      }
      if (!this.form.address) {
        this.$toast.fail('地址不能为空')
        return
      }
      if (this.form.isOnlinepay==1 && !this.form.receiptUrl){
        this.$toast.fail('请上传转账证明')
        return
      }
      this.disabsold = false
      if (this.disabsold) {
        return
      }
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.form.isWeb = 0;
      } else {
        this.form.isWeb = 1;
      }
      this.disabsold = true
      if (this.form.payType && !this.form.isOnlinepay) {
        wxPayServiceFee(this.form).then((res) => {
          if (res.success) {
            const data = res.payMap
            if(data.payUrl) {
              window.location = data.payUrl
            } else {
              WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                  appId: data.appId, // 公众号名称(商户appid)
                  timeStamp: data.timeStamp, // 时间戳，自1970年以来的秒数
                  nonceStr: data.nonceStr, // 随机串
                  package: data.package,
                  signType: data.signType, // 微信签名方式：
                  paySign: data.paySign // 微信签名
                }, (r) => {
                  if (r.err_msg == 'get_brand_wcpay_request:ok') {
                    this.$router.push({
                      path: '/order'
                    })
                    return;
                    const params = {
                      orderNo: res.ordersn
                    }
                    queryorder(params).then((d) => {
                      // 使用以上方式判断前端返回,微信团队郑重提示：
                      if (d.success) {
                        this.$router.push({
                          path: '/order'
                        })
                      }
                    })
                  }
                })
            }
            // wxPayServiceFee()
            // this.$toast.success('成功!')
          } else {
            this.disabsold = false
            this.$toast.fail(res.msg)
          }
        })
      } else {
        saveShopOrder(this.form).then((res) => {
          if (res.success) {
            //this.$store.dispatch('GetUserInfo')
            this.$toast.success(res.msg)
            setTimeout((res) => {
              this.$router.push({
                path: '/order'
              })
            }, 1000)
          } else {
            this.disabsold = false
          }
        })
      }
    },
    submit() {
      this.$dialog.confirm({
        title: '是否确认支付'
      }).then(() => {
        this.pay();
      }).catch(() => {

      });
    },
    // 上传成功后回调
    afterRead(file) {
      uploadimage(file.file).then((res) => {
        if (res.success) {
          this.fileList.push({ url: res.data })
          this.form.receiptUrl = res.data
        }
      })
    },
    // 删除图片
    deleteImg(e) {
      this.fileList.splice(0, 1)
    },
    // 获取默认地址
    getList() {
      var user = localStorage.getItem("userInfo")
      user = JSON.parse(user)
      queryShopAddressList({ uid: user.id, isDefault: true }).then(res => {
        if (res.success) {
          this.addressList = res.data
          if (res.data.length > 0){
            const data = res.data[0]
            this.form.receiver = data.name
            this.form.tel = data.tel
            this.form.address = data.address
            this.form.detail = data.detail
          }
        }
      })
    },

    // 返利金额
    _querySysRebateList() {
      querySysRebateList({ type: 0 }).then((res) => {
        const price = ((this.$route.query.price) * this.value - this.form.couponPrice)
        this.flMoney = (price - (price * res.data[0].taxes) - res.data[0].wdMoney - res.data[0].freight) * res.data[0].wdRate
      })
    },
    // 查询该商品是否有可用优惠劵
    getCouponList() {
      let user = JSON.parse(localStorage.getItem("userInfo"))
      let param = {
        uid: user.id,
        cartItemList: this.orderItemList
      }
      usableCoupon(param).then((res) => {
        if (res.success) {
          this.couponList = res.data
        }
      })
    },
    //选择开票类型
    changeOpenType(value){
      this.form.opentype = value;
    },

    radioClick (e) {
      if (e){
        e === this.activeCoupon1? (this.activeCoupon = '',this.activeCoupon1 = ''):(this.activeCoupon = e,this.activeCoupon1 = e)
      }
    },
    // 获取选中的优惠劵id
    changeCoupon(value) {
      if (!value){
        this.form.cid = ''
        this.form.siid = ''
        this.form.couponPrice = ''
        this.couponTip = ''
      }
      this.couponList.forEach((item) => {
        if (item.id == value) {
          this.form.cid = item.id
          this.form.siid = item.cid
          this.form.couponPrice = item.money
          this.couponTip = item.title
        }
      })
    },
    onNavigate() {

      // this.expressName = name
      // this.expressActive = index
      // this.form.freightType = index
      // this.form.shippingAmount = 0

      // this.couponTip = item.title
      // this.form.cid = item.cid
      // this.form.siid = item.id
      // this.form.couponPrice = item.money
      let form = {
        cid: this.form.cid,
        siid: this.form.siid,
        couponPrice: this.form.couponPrice,
        freightType: this.form.freightType,
        shippingAmount: this.form.shippingAmount,
      };
      this.$router.push({
        path: '/ticket/list',
        query: {
          ...this.query,
          expressName: this.expressName,
          expressActive: this.expressActive,
          couponTip: this.couponTip,
          form: JSON.stringify(form),
          isOnlinepay: this.form.isOnlinepay,
        }
      })
    },
    handleAddress() {
      let form = {
        cid: this.form.cid,
        siid: this.form.siid,
        couponPrice: this.form.couponPrice,
        freightType: this.form.freightType,
        shippingAmount: this.form.shippingAmount,
      };
      this.$router.push({
        path: '/address/list',
        query: {
          path: "/order/add",
          ...this.query,
          currentItem: this.currentItem,
          expressName: this.expressName,
          expressActive: this.expressActive,
          couponTip: this.couponTip,
          form: JSON.stringify(form),
          isOnlinepay: this.form.isOnlinepay
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .synopsis{
    width:95%;
    height:100px;
    background:rgba(255,255,255,1);
    border:1px solid rgba(243,243,243,1);
    opacity:1;
    border-radius:6px;
    padding: 10px;
  }
  .container{
    //background: #EDEDED;
    .order-header{
      background: #FFFFFF;
      padding: 44px 12px;
      .address{
        display: flex;
        justify-content: center;
        align-items: center;
        height:50px;
        border-radius:4px;
        border:1px dashed rgba(254,0,59,1);
        .add{
          margin-left: 10px;
          height:22px;
          font-size:16px;
          font-weight:400;
          line-height:22px;
          color:rgba(102,102,102,1);
        }
      }
    }
    .order-address{
      padding: 0 12px;
      .order-address-main{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 11px 10px;
        background:rgba(255,255,255,1);
        box-shadow:0px 1px 2px rgba(0,0,0,0.16);
        border-radius:4px;
        .content{
          flex: 1;
          margin-left: 15px;
          .name{
            font-size:14px;
            font-weight:bold;
            color:rgba(51,51,51,1);
          }
          .tel{
            margin-top: 9px;
            font-size:12px;
            font-weight:400;
            line-height:17px;
            color:rgba(102,102,102,1);
          }
          .address{
            margin-top: 3px;
            font-size:12px;
            font-weight:400;
            line-height:17px;
            color:rgba(102,102,102,1);
          }
        }
      }
    }
    .product{
      background:rgba(255,255,255,1);
      box-shadow:0px 1px 2px rgba(0,0,0,0.16);
      border-radius:6px;
      margin: 4px 12px;
      padding: 16px 10px;
      .product-info{
        display: flex;
        flex-direction: row;
        .content{
          flex: 1;
          margin-left: 20px;
          .title{
            font-size:13px;
            font-weight:400;
            line-height:18px;
            color:rgba(51,51,51,1);
          }
          .price{
            height:18px;
            font-size:13px;
            font-weight:400;
            line-height:18px;
            color:rgba(51,51,51,1);
            margin-top: 10px;
          }
          .sku{
            height:20px;
            font-size:12px;
            font-weight:400;
            line-height:20px;
            color:rgba(136,137,136,1);
            background:rgba(243,243,243,1);
            padding-left: 3px;
            margin-top: 10px;
          }
        }
      }
      .total{
        display: flex;
        flex-direction: row-reverse;
        font-size:13px;
        font-weight:400;
        line-height:25px;
        color:rgba(51,51,51,1);
        margin-top: 12px;
        position: relative;
      }
      .postage{
        height:20px;
        font-size:14px;
        font-weight:400;
        line-height:20px;
        color:#333333;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 17px;
        cursor: pointer;
      }
      .ticket{
        /*height:20px;*/
        font-size:14px;
        font-weight:400;
        line-height:20px;
        color:#333333;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 25px;
        cursor: pointer;
      }
    }
    .payment{
      margin: 10px 12px;
      padding: 11px 12px;
      background:rgba(255,255,255,1);
      box-shadow:0px 1px 2px rgba(0,0,0,0.16);
      border-radius:6px;
      .title{
        height:22px;
        font-size:16px;
        font-weight:bold;
        line-height:22px;
        color:rgba(51,51,51,1);
      }
      .content{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        .item{
          margin-top: 10px;
          .item-img{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width:50px;
            height:50px;
            opacity:1;
            border-radius:6px;
          }
          .name{
            height:20px;
            font-size:14px;
            font-weight:400;
            line-height:21px;
            color:rgba(102,102,102,1);
          }
        }
      }
      .tip{
        font-size:10px;
        font-weight:400;
        line-height:21px;
        color:rgba(254,0,59,1);
        text-align: right;
      }
    }
    .choose{
      padding: 0 15px;
      .item{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px 0;
        .name{
          display: flex;
          flex-direction: row;
          align-items: center;
          .text{
            display: inline-block;
            margin-left: 10px;
          }
        }
      }
    }
    .footer{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height:50px;
      background:rgba(255,255,255,1);
      box-shadow:0px 1px 2px rgba(0,0,0,0.16);
      padding: 0 12px 0 12px;
      .model{
        position: absolute;
        height: 220px;
        background: #FFFFFF;
        top: -220px;
        left: -10px;
        box-shadow: 0 0 5px #DEDEDE;
        .model-item{
          display: flex;
          flex-direction: row;
          padding: 5px 9px;
          width: 100%;
          height: 2.5rem;
          box-sizing: border-box;
          .model-item-name{
            display: block;
            color: #333333;
            font-size: 10px;
            width: 60px;
          }
          .model-item-text{
            flex: 1;
            display: block;
            font-size: 0.8125rem;
            color: #FF0000;
            overflow: hidden;
          }
        }
      }
      .total{
        height:50px;
        font-size:14px;
        font-weight:bold;
        line-height:50px;
        color:rgba(51,51,51,1);
        .money{
          height:50px;
          font-size:15px;
          font-weight:bold;
          line-height:50px;
          color:rgba(254,0,59,1);
        }
      }
      .submit{
        width:100px;
        height:40px;
        background:linear-gradient(0deg,rgba(244,4,66,1) 0%,rgba(226,23,75,0.73) 100%);
        border-radius:4px;
        font-size:16px;
        font-weight:400;
        line-height:40px;
        color:rgba(255,255,255,1);
        text-align: center;
      }
    }
    .popup{
      .popuphead{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
      }
      .close{
        color: #C7C7C7;
        font-size: 25px;
      }
      .confirm{
        font-size:14px;
        font-weight:400;
        color:rgba(254,0,59,1);
      }
      .active{
        color:rgba(254,0,59,1)!important;
      }
      .type{
        height: 45px;
        line-height: 45px;
        border-top: 1px solid #DDDDDD;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        opacity:1;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/order/add.vue